import React, { useRef } from 'react'
import './BannerUpload.scss'
import { serverUrl } from '../../../../../request'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faPlus } from '@fortawesome/free-solid-svg-icons'

interface FileWithPreview extends File {
  preview: string
}

type Props = {
  files: FileWithPreview[]
  setFiles: React.Dispatch<React.SetStateAction<FileWithPreview[]>>
  setImages: React.Dispatch<React.SetStateAction<string[]>>
  images: Array<string>
  setDeletedImages: React.Dispatch<React.SetStateAction<string[]>>
}

const MAX_IMAGES = 4
const c = 'banner-upload'

const BannerUpload = ({ files, setFiles, images, setImages, setDeletedImages }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const totalCount = images.length
  const emptySlots = MAX_IMAGES - totalCount

  function handleFileSelect(e: React.ChangeEvent<HTMLInputElement>) {
    const selected = Array.from(e.target.files || [])
    const allowed = MAX_IMAGES - totalCount
    const picked = selected.slice(0, allowed)

    const newFiles = picked.map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) }),
    ) as FileWithPreview[]

    setFiles((prev) => [...prev, ...newFiles])
    setImages((prev) => [...prev, ...newFiles.map((f) => f.preview)])

    // reset so the same file can be re-selected if needed
    e.target.value = ''
  }

  function handleDeleteImage(url: string) {
    if (!url.startsWith('blob:')) {
      // Queue for deletion on Save (don't call API yet)
      setDeletedImages((prev) => [...prev, url.replace(serverUrl, '')])
    } else {
      // Remove the corresponding FileWithPreview entry
      setFiles((prev) => prev.filter((f) => f.preview !== url))
    }
    setImages((prev) => prev.filter((image) => image !== url))
  }

  return (
    <section className={c}>
      <p className={`${c}__label`}>
        Imagini banner ({totalCount}/{MAX_IMAGES})
      </p>
      <div className={`${c}__grid`}>
        {images.map((image, index) => (
          <div key={image} className={`${c}__slot ${c}__slot--filled`}>
            <img src={image} alt={`banner-${index + 1}`} />
            <button
              type='button'
              className={`${c}__delete`}
              onClick={() => handleDeleteImage(image)}
              aria-label='Delete image'
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
          </div>
        ))}

        {emptySlots > 0 &&
          Array.from({ length: emptySlots }).map((_, i) => (
            <div
              key={`empty-${i}`}
              className={`${c}__slot ${c}__slot--empty`}
              onClick={() => inputRef.current?.click()}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>Adaugă</span>
            </div>
          ))}
      </div>

      <input
        ref={inputRef}
        type='file'
        accept='image/*'
        multiple
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
    </section>
  )
}

export default BannerUpload
